<template>
    <div
            class="price-arrows"
            :data-hideOnBalloon="hideOnBalloon"
    >
        <div v-if="isPriceUp">
            <i class="price-up fas fa-arrow-up m-2" />
        </div>
        <div v-else-if="isPriceDown">
            <i class="price-down fas fa-arrow-down m-2" />
        </div>
    </div>
</template>

<script>
    export default {
        name: "PropertyListingCardPriceArrows",
        props: {
            hideOnBalloon: {
                type: Boolean,
                required: true,
            },
        },
        computed: {
            /**
             * Check if the price has risen
             *
             * @returns {boolean}
             */
            isPriceUp() {
                return false;
            },

            /**
             * Check if the price was reduced
             * @returns {boolean}
             */
            isPriceDown() {
                return false;
            }
        },
    };
</script>
